import { AssetAmount } from "@sundaeswap/asset";
import { useMemo } from "react";
import { ADA_TX_FEE } from "../../constants/SundaeSwap.constants";
import { ADA_METADATA } from "../../constants/cardano.constants";
import { EOrderTransactionBuilderState, useOrderContext } from "../../stores/OrderContext";

export const useTasteTestWithdrawOrderFees = () => {
  const {
    state: {
      derived: { transaction },
    },
  } = useOrderContext();

  const memoizedAdaTxFee = useMemo(() => {
    if (transaction?.state === EOrderTransactionBuilderState.SUCCESS) {
      return transaction?.builtTx?.fees?.cardanoTxFee ?? ADA_TX_FEE;
    }
    return undefined;
  }, [transaction?.builtTx?.fees?.cardanoTxFee, transaction?.state]);

  const memoizedPenaltyFee = useMemo(() => {
    if (transaction?.state === EOrderTransactionBuilderState.SUCCESS) {
      return transaction?.builtTx?.fees?.penaltyFee ?? new AssetAmount(0n, ADA_METADATA);
    }
    return undefined;
  }, [transaction?.builtTx?.fees?.penaltyFee, transaction?.state]);

  const memoizedTotalFee = useMemo(() => {
    if (memoizedAdaTxFee && memoizedPenaltyFee) {
      return memoizedAdaTxFee.add(memoizedPenaltyFee);
    }

    if (memoizedAdaTxFee) {
      return memoizedAdaTxFee;
    }

    return new AssetAmount(0n, ADA_METADATA);
  }, [memoizedAdaTxFee, memoizedPenaltyFee]);

  return {
    adaTxFee: memoizedAdaTxFee,
    penaltyFee: memoizedPenaltyFee,
    totalFee: memoizedTotalFee,
  };
};
